<template>
  <div>
    <b-form inline method="POST" action="https://stay.activehosted.com/proc.php" novalidate>
      <b-form-input hidden name="u" value="4" />
      <b-form-input hidden name="f" value="4" />
      <b-form-input hidden name="s" />
      <b-form-input hidden name="c" value="0" />
      <b-form-input hidden name="m" value="0" />
      <b-form-input hidden name="act" value="sub" />
      <b-form-input hidden name="v" value="2" />
      <b-input-group class="newsletter-input-group">
        <b-form-input text name="email" placeholder="Email address" required/>
        <b-input-group class="input-group-append">
          <b-button variant="primary" type="submit">
            Subscribe
          </b-button>
        </b-input-group>
      </b-input-group>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'NewsletterSubscribe',
}
</script>

<style scoped>
  .newsletter-input-group{
    width:100% !important;
  }
  .input-group{
    width:auto;
  }
</style>